import { makeStyles, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { LTR_STEP, SMART_T_STEP } from "libs/constant/Step";
import { STATUS_REPORT_STEP } from "libs/constant/VisaStep";
import { ReactImageTint } from "react-image-tint";
import { useDispatch, useSelector } from "react-redux";
import { companySlice } from "redux/modules/companySlice";
import { setStep } from "redux/modules/statusReportSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import { selectCurrentSmartForm } from "redux/modules/visaForm";

const useStyles = makeStyles((theme) => ({
  steper: {
    display: "flex",
    flexDirection: "row",
    position: "relative",
    minWidth: 500,
  },
  stepItem: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    alignItems: "center",
    color: "#97bad0",
    cursor: "pointer",
    zIndex: 999,
  },
  stepIcon: {
    width: 50,
    height: 50,
    borderRadius: 50,
    backgroundColor: "#1ea87a",
    marginTop: 14,
    marginBottom: 8,
    border: "2px solid #cbdde7",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    display: "flex",
  },
  checker: {
    display: "block",
    position: "absolute",
    marginTop: 45,
    marginLeft: -65,
    width: 14,
    height: 14,
    borderRadius: 14,
    fontSize: 10,
    color: "#ffffff",
    backgroundColor: "#97bad0",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  iconWraper: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    alignSelf: "stretch",
    alignItems: "center",
  },
  lineLeft: {
    display: "flex",
    flex: 1,
    height: 3,
    backgroundColor: "red",
  },
  lineRight: {
    display: "flex",
    flex: 1,
    height: 3,
    backgroundColor: "red",
  },
}));

function Steper({
  currentStep = 0,
  stepInfo,
  activeColor = "#1ea87a",
  inactiveColor = "#97bad0",
  inactiveIconColor = "#dcf2fd",
  inactiveLineColor = "#f6f6fb",
  onClickStep,
  isExtend,
  isStatusReport,
  isLTR,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const smartform = useSelector(selectCurrentSmartForm); // selectCurrentSmartForm

  const handleOnClickStep = (index) => {
    if (onClickStep) {
      return onClickStep(index);
    }

    if (isExtend) {
      switch (index) {
        case 0:
          dispatch(setSmartFormStep(SMART_T_STEP.PART_A_1));
          break;
        case 1:
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
          break;
        default:
          break;
      }
      return;
    }

    if (isStatusReport) {
      switch (index) {
        case 0:
          dispatch(setStep(STATUS_REPORT_STEP.STATUS_REPORT_STEP_A));
          break;
        case 1:
          dispatch(setStep(STATUS_REPORT_STEP.STATUS_REPORT_STEP_B));
          break;
        default:
          break;
      }
      return;
    }

    if (isLTR) {
      dispatch(companySlice.actions.clearAll());
      switch (index) {
        case 0:
          dispatch(setSmartFormStep(LTR_STEP.UPLOAD_PASSPORT));
          break;
        case 1:
          dispatch(setSmartFormStep(LTR_STEP.SHOW_FORM_STEP));
          break;
        case 2:
          dispatch(setSmartFormStep(LTR_STEP.SHOW_FORM_WORKPERMITSTEP));
          break;
        case 3:
          dispatch(setSmartFormStep(LTR_STEP.UPLOAD_DOCUMENT));
          break;

        default:
          break;
      }
      return;
    }

    switch (index) {
      case 0:
        dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
        break;
      case 1:
        dispatch(setSmartFormStep(SMART_T_STEP.PART_A_1));
        break;
      case 2:
        dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        break;
      default:
        break;
    }
  };

  return (
    <div>
      {!isLTR && smartform.draftRemark && <Alert severity="error" style={{ marginTop: 18, marginBottom: 18 }}>{smartform.draftRemark}</Alert>}
      <div className={classes.steper}>
        {stepInfo.map((step, index) => {
          const isPassed = index <= currentStep;

          const currentStepColor = isPassed
            ? step.activeColor || activeColor
            : inactiveColor;

          return (
            <div
              key={step.hearding}
              className={classes.stepItem}
              onClick={() => handleOnClickStep(index)}
            >
              <Typography variant="h6" component="h4">
                {step.hearding}
              </Typography>
              <div className={classes.iconWraper}>
                <div
                  className={classes.lineLeft}
                  style={{
                    backgroundColor:
                      index === 0
                        ? "transparent"
                        : isPassed
                          ? currentStepColor
                          : inactiveLineColor,
                  }}
                />
                <div
                  id="stepIcon"
                  className={classes.stepIcon}
                  style={{
                    backgroundColor: isPassed
                      ? currentStepColor
                      : inactiveIconColor,
                    borderColor: currentStepColor,
                  }}
                >
                  {isPassed ? (
                    <ReactImageTint
                      className={classes.icon}
                      alt="step-icon"
                      src={step.icon}
                      color="#ffffff"
                    />
                  ) : (
                    <ReactImageTint
                      className={classes.icon}
                      alt="step-icon-inactive"
                      src={step.icon}
                      color={inactiveColor}
                    />
                  )}

                  {isPassed && (
                    <span
                      className={classes.checker}
                      style={{ backgroundColor: currentStepColor }}
                    >
                      ✓
                    </span>
                  )}
                </div>
                <div
                  className={classes.lineRight}
                  style={{
                    backgroundColor:
                      index === stepInfo.length - 1
                        ? "transparent"
                        : isPassed
                          ? currentStepColor
                          : inactiveLineColor,
                  }}
                />
              </div>
              <Typography variant="h6" style={{ color: currentStepColor }}>
                {step.title}
              </Typography>
              <Typography color="textPrimary">{step.description}</Typography>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Steper;
